import React from 'react';
import { Grid, Loader, Col, Title } from '@common/components';
import loaderClasses from './LoaderSampleView.module.scss';

export default function LoaderSampleView() {
  return (
    <div className={loaderClasses.loader}>
      <Title type="h1">Loader demo</Title>
      <div className={loaderClasses.loaderGrid}>
        <Grid>
          <Col xs={6}>
            <div className={loaderClasses.item}>
              <Loader size="normal" />
              <span>normal primary</span>
            </div>
            <div className={loaderClasses.item}>
              <Loader size="big" />
              <span>big primary</span>
            </div>
          </Col>
          <Col xs={6}>
            <div className={loaderClasses.item}>
              <Loader size="normal" color="white" />
              <span>normal white</span>
            </div>
            <div className={loaderClasses.item}>
              <Loader size="big" color="white" />
              <span>big white</span>
            </div>
          </Col>
        </Grid>
      </div>
    </div>
  );
}
